import React from "react";
import SkyLight from "react-skylight";
import LineItem from "./LineItem";
import _ from "underscore";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addViewClaims, isRecentBatch } from "~/app/submit_claims/upload/actions";
import { kinetik_api_url, convertFieldName, b64toBlob } from "~/app/utilities";
import axios from 'axios';
import toastr from 'toastr'
import MDSpinner from "react-md-spinner";
import { DropdownButton, MenuItem } from 'react-bootstrap';

class CMS1500 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      claim: null,
      fields: {
        ins_number: null,
        from_date_1: null,
        pat_name_f: null,
        pat_name_l: null,
        pat_sex: null,
        pat_dob: null,
        pat_addr_1: null,
        pat_addr_2: null,
        pat_state: null,
        pat_city: null,
        pat_zip: null,
        prior_auth: null,
        resubmission_code: null,
        orig_claim_ref:null,
      },
      classNames: {
        ins_number: "",
        from_date_1: "",
        pat_name_f: "",
        pat_name_l: "",
        pat_sex: "",
        pat_dob: "",
        pat_addr_1: "",
        pat_addr_2: "",
        pat_state: "",
        pat_city: "",
        pat_zip: "",
        prior_auth: "",
        orig_claim_ref: "",
      },
      lineItemsFields: null,
      line_items: 0,
      exportSpinner: false,
    };
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.rowData !== this.props.rowData) {
      this.simpleDialog.show();

      this.setState({
        claim: nextProps.rowData,
        fields: {
          ins_number: nextProps.rowData.ins_number,
          from_date_1: nextProps.rowData.from_date_1,
          pat_name_f: nextProps.rowData.pat_name_f,
          pat_name_l: nextProps.rowData.pat_name_l,
          pat_sex: nextProps.rowData.pat_sex,
          pat_dob: nextProps.rowData.pat_dob,
          pat_addr_1: nextProps.rowData.pat_addr_1,
          pat_addr_2: nextProps.rowData.pat_addr_2,
          pat_state: nextProps.rowData.pat_state,
          pat_city: nextProps.rowData.pat_city,
          pat_zip: nextProps.rowData.pat_zip,
          prior_auth: nextProps.rowData.prior_auth,
          resubmission_code: nextProps.rowData.resubmission_code,
          orig_claim_ref: nextProps.rowData.orig_claim_ref,
        },
        line_items: nextProps.rowData.line_items
      });

      this.highlightErrors(nextProps.rowData);

    }
  };

  handleChange = (event, field) => {
    let currentFields = this.state.fields;
    currentFields[field] = event.target.value;
    //let classNames= this.state.classNames;
    let claim = Object.assign({}, this.state.claim)
    const index = _.findIndex(claim.error, error => {
      return error._attributes.fields === field;
    });

    if (index !== -1) {
      //remove errors if the current field is in the errors obj
      claim.error.splice(index, 1);
    }

    this.highlightErrors(claim);
    this.setState({ fields: currentFields, claim });
    this.claimFieldsCheck();

  };


  claimFieldsCheck = () => {
    let claimError = Object.assign([], this.state.claim.error)
    const allFields = this.state.fields;
    if (claimError === null) {
      claimError = [];
    }
    _.each(allFields, (val, key) => {
      if (val === "" && key !== "prior_auth" && key !== "pat_addr_2" && key !== "pickup_addr_2" && key !== "dropoff_addr_2") {
        const err = {
          _attributes: {
            fields: key,
            mesgid: "NULL",
            message: convertFieldName(key) + " cannot be empty",
            status: "R"
          }
        };
        claimError.push(err);

      }
    });
    claimError = _.uniq(claimError, err => {
      //to limit num of err for each field to 1
      return err._attributes.fields;
    })
    if (!_.isEqual(claimError, this.state.claim.error)) {
      let newClaim = this.state.claim;
      newClaim.error = claimError;
      this.highlightErrors(newClaim);
      this.setState({ claim: newClaim })
    }
    // if(claim!==this.state.claim){
    //   this.setState(claim);
    // }
  };

  renderErrMsg = () => {
    const claim = this.state.claim;
    if (claim !== null) {
      return _.map(claim.error, err => {
        const fieldName = err._attributes.fields;
        if (fieldName.substring(0, 3) !== "ins" || fieldName === "ins_number") {
          //Prevent Ins errors to be listed.
          return (
            <p
              key={err._attributes.fields}
              id={"err_" + err._attributes.fields}
            >
              {convertFieldName(err._attributes.fields)} : {err._attributes.message}{" "}
            </p>
          );
        }
      });
    }
  };
  handleLineItemsChange = (fields, errors) => {
    this.setState({ lineItemsFields: fields })
  }
  handleLineItemCount = (line_items) => {
    this.setState({ line_items })
  }

  highlightErrors = (claim) => {
    if (claim !== null) {
      let classNames = _.create("", this.state.classNames);
      _.each(classNames, (val, key) => {
        //resetting classNames
        classNames[key] = "";
      });

      _.each(claim.error, error => {
        classNames[error._attributes.fields] = " claim-input-error" //highlighting error ones
      })
      if (!_.isEqual(classNames, this.state.classNames)) {
        this.setState({ classNames })
      }
    }
  };

  createNewLineItem = () => {
    var x = document.getElementById("line-item2");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  };
  showCMS1500 = (isShowing, data) => {
    if (isShowing) {
      this.simpleDialog.show();
    }
  };

  saveClaim = () => {
    const fields = this.state.fields;
    const lineItemsFields = this.state.lineItemsFields;
    let claim = this.state.claim;

    //Update database claim based on changed fields
    _.each(fields, (val, key) => {
      //updating claim with fieldss in cms1500
      claim[key] = val === "" ? null : val;
      claim["status"] = "Ready"

    });

    if (lineItemsFields !== null) {
      console.log("LINE ITEMS", lineItemsFields)
      /// updating line item fields to the claim
      let totalCharge = parseFloat(0);
      _.each(lineItemsFields, (val, key) => {
        console.log("LINE ITEMS FIELDS", lineItemsFields)
        if (key.includes("charge") && val !== undefined && val !== null) {
          console.log("CHANGED VALS", val)

          totalCharge = parseFloat(totalCharge) + parseFloat(val)
        }
        claim[key] = val === "" ? null : val;
      });
      claim["total_charge"] = totalCharge === "" ? null : parseFloat(totalCharge).toFixed(2)
      claim["status"] = "Ready"

    }

    if (claim.status === "R" && claim.error.length === 0) { //changing status to ready after errors are fixed
    //if (claim.status === "R") { 
      claim.status = "Ready";
    } else if (claim.status !== "R" && claim.error !== null && claim.error.length !== 0) {
      claim.status = "R";
    }
    this.setState({ claim });

    let view_claims = Object.assign([], this.props.view_claims);
    _.each(view_claims, (vClaim, index) => {
      if (vClaim.remote_claimid === claim.remote_claimid) {
        view_claims[index] = claim;
        view_claims[index].line_items = this.state.line_items
      }
    });

    const claimsToUpdate = Object.assign([], view_claims);
    this.props.addViewClaims(claimsToUpdate);
    this.getDBClaim(fields, lineItemsFields, claim)
    this.props.isRecentBatch(false);
    this.simpleDialog.hide();
  };

  getDBClaim = (fields, lineItemsFields, claim) => {
    const token = localStorage.getItem('authToken')
    let URL = kinetik_api_url + '/claim/' + claim.remote_claimid + "?token=" + token;
    axios.get(URL)
      .then((response) => {
        let dbClaim = response.data.message
        //updating db claim with fields in cms1500

        _.each(fields, (val, key) => {
          if (key.includes("pat") || key === "ins_number") {
            dbClaim.patient[key] = val
          }
          else {
            dbClaim[key] = val
            dbClaim["status"] = "Ready"
          }
          claim[key] = val;

        });

        if (lineItemsFields !== null) {
          // /// updating line item fields to the claim
          let totalCharge = parseFloat(0);
          _.each(lineItemsFields, (val, key) => {
            if (key.includes("charge") && val !== undefined && val !== null) {
              totalCharge = parseFloat(totalCharge) + parseFloat(val)
            }
            dbClaim[key] = val === "" ? null : val;
          });
          dbClaim["total_charge"] = totalCharge === "" ? null : parseFloat(totalCharge).toFixed(2)
          dbClaim["status"] = "Ready"

        }

        dbClaim.line_items = this.state.line_items
        this.updateDBClaim(dbClaim);
      })
  }
  updateDBClaim = (claim) => {
    console.log("claim that needs to be updated", claim)
    var token = localStorage.getItem('authToken');
    axios.post(kinetik_api_url + "/claim/update", { claim, token }).then((res) => {
      if (res.data.success) {
        toastr.success("Claim Updated Successfully")
      }
      else {
        toastr.error("Claim Failed to Update!")
      }
    })
  }

  renderSaveButton = () => {
    const claim = this.state.claim;
    if (claim !== null) {
      return (
        <div className="modal-footer">
          <div>{this.renderErrMsg()}</div>
          <div>
            <button type="button" class="btn btn-primary export-btn export-cms " onClick={() => this.exportClaim()}>
              <span class="glyphicon glyphicon-save"></span> Export
                </button>
            {/* {(this.state.claim!=null && this.state.claim.payerid==="99999")&& */}
            <DropdownButton className="dropdown-batch-status" title={this.state.fields.resubmission_code==null?"Original":this.state.fields.resubmission_code} onSelect={this.handleResubmissionCode}>
                <MenuItem  eventKey="Original">Original</MenuItem>
                <MenuItem  eventKey="Correction">Correction</MenuItem>
                <MenuItem  eventKey="Void">Void</MenuItem>
            </DropdownButton>
            {/* } */}

  

            <button
              className="cancel-btn"
              onClick={() => this.simpleDialog.hide()}
            >
              Cancel
          </button>
            <button className="save-btn" onClick={() => this.saveClaim()}>
              Save
          </button>

          </div>
        </div>
      )
    }

  }
  
  handleResubmissionCode = (selectedVal) => {
    let fields = Object.assign({},this.state.fields);
    fields.resubmission_code= selectedVal;
    this.setState({fields})
  }
  exportClaim = () => {
    this.setState({ showExportSpinner: true })
    const claim = this.state.claim
    let URL = kinetik_api_url + '/generate1500/' + claim.remote_claimid;
    axios.get(URL)
      .then((response) => {
        if (response.data.success) {
          const base64Data = response.data.data[0]
          const claim = response.data.data[1]

          const blob = b64toBlob(base64Data)

          //Support for IE
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
            this.setState({ showExportSpinner: false })

            return;
          }
          //Support for all other browsers
          const data = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = data;
          link.download = claim.patient.pat_name_l + "," + claim.patient.pat_name_f + " " + claim.from_date_1 + ".pdf";
          this.setState({ showExportSpinner: false })

          link.click();
        }
        else {
          this.setState({ showExportSpinner: false })

          toastr.error("Claim Failed to Export!")
        }
      })
  }




  render() {
    return (
      <div>
        <SkyLight
          hideOnOverlayClicked
          ref={ref => (this.simpleDialog = ref)}
          dialogStyles={dialog}
        >
          <div>
            <div className="modal-header">
              <div className="modal-header-title">Edit Claim</div>
              <div className="modal-header-subtitle">Fix or View Claim</div>
            </div>
            <form>

              <div className="flex">
                <fieldset className="pat-info">
                  <div>
                    <label htmlFor="pat_name_f">First Name</label>
                    <input
                      autoComplete="off"
                      className={
                        "claim-input " + this.state.classNames.pat_name_f
                      }
                      type="text"
                      id="pat_name_f"
                      value={this.state.fields.pat_name_f}
                      onChange={e => this.handleChange(e, "pat_name_f")}
                    />
                    <label htmlFor="pat_dob">Date of Birth</label>
                    <input
                      autoComplete="off"
                      className={
                        "claim-input claim-input-small" +
                        this.state.classNames.pat_dob
                      }
                      type="text"
                      id="pat_dob"
                      value={this.state.fields.pat_dob}
                      onChange={e => this.handleChange(e, "pat_dob")}
                    />
                  </div>
                  <div>
                    <label htmlFor="pat_name_l">Last Name</label>
                    <input
                      autoComplete="off"
                      className={
                        "claim-input " + this.state.classNames.pat_name_l
                      }
                      type="text"
                      id="pat_name_l"
                      value={this.state.fields.pat_name_l}
                      onChange={e => this.handleChange(e, "pat_name_l")}
                    />

                    <label htmlFor="pat_sex">Sex</label>
                    <input
                      autoComplete="off"
                      className={
                        "claim-input claim-input-small" +
                        this.state.classNames.pat_sex
                      }
                      type="text"
                      id="pat_sex"
                      value={this.state.fields.pat_sex}
                      onChange={e => this.handleChange(e, "pat_sex")}
                    />

                  </div>
                </fieldset>

                <fieldset className="claim-info">
                  <div>
                    <label htmlFor="ins_number">Insured ID Number</label>
                    <input
                      autoComplete="off"
                      className={"claim-input " + this.state.classNames.ins_number}
                      type="text"
                      id="ins_number"
                      value={this.state.fields.ins_number}
                      onChange={e => this.handleChange(e, "ins_number")}
                    />
                    <label htmlFor="from_date_1">Date of Service</label>
                    <input
                      autoComplete="off"
                      className={
                        "claim-input claim-input-small " +
                        this.state.classNames.from_date_1
                      }
                      type="text"
                      id="from_date_1"
                      value={this.state.fields.from_date_1}
                      onChange={e => this.handleChange(e, "from_date_1")}
                    />
                  </div>
                  <div>
                    <label htmlFor="prior_auth">Prior Authorization #</label>
                    <input
                      autoComplete="off"
                      className={
                        "claim-input" +
                        this.state.classNames.prior_auth
                      }
                      type="text"
                      id="prior_auth"
                      value={this.state.fields.prior_auth}
                      onChange={e => this.handleChange(e, "prior_auth")}
                    />

                    {/* {(this.state.claim!=null && this.state.claim.payerid==="99999")&& */}
                    <span>
                       <label htmlFor="orig_claim_ref">Original Claim Ref #</label>
                       <input
                         autoComplete="off"
                         className={
                             "claim-input claim-input-small " +
                             this.state.classNames.orig_claim_ref
                         }
                         type="text"
                         id="orig_claim_ref"
                         value={this.state.fields.orig_claim_ref}
                         onChange={e => this.handleChange(e, "orig_claim_ref")}
                       />
                    </span>
                  {/* } */}
                  
                  </div>
                </fieldset>
              </div>

              <div>
                <fieldset className="pat-loc-info">

                  <div>
                    <label htmlFor="pat_addr_1">Address Line 1</label>
                    <input
                      autoComplete="off"
                      className={"claim-input" + this.state.classNames.pat_addr_1}
                      type="text"
                      id="pat_addr_1"
                      value={this.state.fields.pat_addr_1}
                      onChange={e => this.handleChange(e, "pat_addr_1")}
                    />
                    <label htmlFor="pat_addr_2">Address Line 2</label>
                    <input
                      autoComplete="off"
                      className={"claim-input claim-input-small" + this.state.classNames.pat_addr_2}
                      type="text"
                      id="pat_addr_2"
                      value={this.state.fields.pat_addr_2}
                      onChange={e => this.handleChange(e, "pat_addr_2")}
                    />
                    <label htmlFor="pat_city">City</label>
                    <input
                      autoComplete="off"
                      className={"claim-input" + this.state.classNames.pat_city}
                      type="text"
                      id="pat_city"
                      value={this.state.fields.pat_city}
                      onChange={e => this.handleChange(e, "pat_city")}
                    />
                    <label htmlFor="pat_state">State</label>
                    <input
                      autoComplete="off"
                      className={
                        "claim-input claim-input-small" +
                        this.state.classNames.pat_state
                      }
                      type="text"
                      id="pat_state"
                      value={this.state.fields.pat_state}
                      onChange={e => this.handleChange(e, "pat_state")}
                    />

                    <label htmlFor="pat_zip">Zip</label>
                    <input
                      autoComplete="off"
                      className={
                        "claim-input claim-input-small" +
                        this.state.classNames.pat_zip
                      }
                      type="text"
                      id="pat_zip"
                      value={this.state.fields.pat_zip}
                      onChange={e => this.handleChange(e, "pat_zip")}
                    />
                  </div>
                </fieldset>
              </div>


              <LineItem data={this.state.claim} getLineItems={(fields, errors) => this.handleLineItemsChange(fields, errors)} getLineItemCount={(line_items) => this.handleLineItemCount(line_items)} />


            </form>

            {this.renderSaveButton()}

          </div>
        </SkyLight>
      </div>
    );
  }
}


var dialog = {
  width: "fit-content",
  height: "590px",
  position: "fixed",
  top: "40%",
  left: "50%",
  marginTop: "-200px",
  marginLeft: "-25%",
  backgroundColor: "#ffffff",
  borderRadius: "10px",
  zIndex: "100",
  padding: "15px",
  boxShadow: "rgba(0, 0, 0, 0.14) 0px 0px 4px, rgba(0, 0, 0, 0.28) 0px 4px 8px",
  transform: "scale(1)",
  transitionProperty: "transform",
  transitionTimingFunction: "ease",
  transitionDuration: "5000ms",
  overflow: "auto"
}





const mapStateToProps = state => {
  return {};
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addViewClaims: addViewClaims,
      isRecentBatch: isRecentBatch,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CMS1500);



// WEBPACK FOOTER //
// ./src/app/common/cms_1500/CMS1500.js